<div class="layout">
    <div class="image">Category</div>
    <div class="name">Menu Item</div>
    <div class="price">Coupon Code</div>
    <div class="edit"></div>
</div>